import React, { Component } from 'react'
import _Stripes_Styled from 'components/Stripes/_Stripes_Styled'
import _Stripes_propTypes from 'components/Stripes/_Stripes_propTypes'
import _Stripes_defaultProps from 'components/Stripes/_Stripes_defaultProps'

export default class Stripes extends Component {

  render () {

    const {
      props
    } = this

    return (
      <_Stripes_Styled {...props}>
        <hr />
        <hr />
        <hr />
        <hr />
      </_Stripes_Styled>
    )
  }

  static Styled = _Stripes_Styled
  static defaultProps = _Stripes_defaultProps
  static propTypes = _Stripes_propTypes
}
